<template>
  <div>
    <div v-show="resultadosPrestador.allResults != null && statusLoadingResultado == false">
      <div class="lg:mt-10">
        <div class="lg:w-[100%] h-[35rem] mx-auto w-[95%] mt-4 mb-8 max-lg:overflow-y-auto lg:overflow-x-auto rounded-md lg:grid lg:grid-cols-2">
          <div v-for="result, index in resultadosPrestador.allResults" :key="result.prestador">
            <div class="rounded-lg shadow-md mt-4 bg-white lg:w-[90%] max-lg:w-10/12 mx-auto">
              <div class="py-3 px-6 font-poppins border-b text-base border-gray-300">
                {{result.razao_social}}
              </div>  
              <div class="h-[20rem] max-lg:h-auto">
                <div class="p-6">
                  <h5 class="text-gray-900 text-xl font-semibold mb-2 font-poppins">{{result.nome_fantasia}}</h5>
                  <p class="font-medium" style="color: #006e63; font-weight: 550;">{{result.departamento.nome}}</p>
                  <p class="text-gray-900 mt-8 text-base">
                    <svg class="w-6 h-6 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                    {{result.logradouro}} {{result.endereco}}, {{result.endereco_numero}} - {{result.bairro}}, {{result.cidade}}/{{result.estado}}
                  </p>
                </div>
                <div class="p-2 ml-4 text-base mt-[-20px]">
                  <svg class="w-6 h-6 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                  <a v-for="telefones, telefonesIndex in result.telefones" :key="telefonesIndex" class="lg:ml-1 max-lg:ml-2 w-full font-bold text-emerald-600 hover:text-emerald-800" :href="'tel:' + telefones">{{formatTelefone(telefones)}}</a>
                </div>
                
                <div class="p-6 mt-[-10px] font-medium text-base">
                  <span class="font-bold">Tipo de Estabelecimento:</span> {{result.tipo.nome}}
                </div>

                <div v-if="result.cnpj.length == 11" class="p-2 mt-[-25px] font-medium ml-4 text-base">
                  <span class="font-bold mr-2">CPF:</span>{{result.cnpj | vueBrazil('cpf')}}
                </div>

                <div v-else class="p-2 mt-[-25px] font-medium ml-4 text-base">
                  <span class="font-bold mr-2">CNPJ:</span>{{result.cnpj | vueBrazil('cnpj')}}
                </div>
              </div>

              <div class="flex mt-4 mr-4 mb-1 place-content-end"><img class="w-[35px]" src="@/assets/logoCortada.png" alt=""></div>
              <div class="py-3 px-6 border-t text-end border-gray-300 text-gray-600">
                <div class="max-md:grid ">
                  <button @click.prevent="showPlanos(index, true), getPlanosSelecionados(index)" type="button" class=" max-md:w-full inline-block font-poppins mr-3 px-2 py-2.5 bg-emerald-600 border-emerald-600 border text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-white hover:shadow-lg hover:text-emerald-700 hover:border-emerald-700 focus:bg-white focus:shadow-lg focus:outline-none focus:ring-0 active:bg-emerald-700 focus:text-emerald-700 active:text-emerald-700 active:shadow-lg transition duration-150 ease-in-out">
                  Planos Atendidos
                  </button>

                  <button @click.prevent="getLocalSelecionado(index), showMaps(index, true)"  type="button" class="max-md:mt-4 max-md:w-full inline-block font-poppins px-3 py-2.5 bg-emerald-600 border-emerald-600 border text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-white hover:shadow-lg hover:text-emerald-700 hover:border-emerald-700 focus:bg-white focus:shadow-lg focus:outline-none focus:ring-0 active:bg-emerald-700 focus:text-emerald-700 active:text-emerald-700 active:shadow-lg transition duration-150 ease-in-out">
                  Localização
                  </button>
                </div>

                <div v-if="statusPlanos[index]">
                  <PlanosAtendidos @close="showPlanos(index, false)" />
                </div>

                <div v-if="statusMaps[index]" >
                  <MapsPrestador  @close="showMaps(index, false)"/>   
                </div>  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MapsPrestador from './mapsPrestador.vue';
  import PlanosAtendidos from './planosAtendidos.vue';
  import { mapState } from 'vuex';
  import { api } from "@/services/api.js";

  export default{

    data() {
      return {
        statusMaps: {},
        statusPlanos: {}
      }
    },

    methods: {
      getLocalSelecionado(index) {
        this.$store.dispatch("loadLocalSelecionado", {
          local: this.$store.state.resultPrestador.allResults[index].endereco_completo
        });
      },

      getPlanosSelecionados(index) {
        this.$store.dispatch("loadLoadingPlanosAtendidos", true)
        api.get(`/planos/prestadores/${this.$store.state.resultPrestador.allResults[index].prestador}`)
          .then((response) => {
            this.$store.dispatch("loadPlanosSelecionados", {
              planos: response.data
            });
          }).finally(() => {
              this.$store.dispatch('loadLoadingPlanosAtendidos', false)
            })
          .catch((err) => {
            console.log(err);
          });
      },

      showMaps(id, status) {
          if (status) {
            this.$set(this.statusMaps, id, true);
          }
          else {
            this.statusMaps[id] = false;
          }
      },

      showPlanos(id, status) {
          if (status) {
            this.$set(this.statusPlanos, id, true);
          }
          else {
            this.statusPlanos[id] = false;
          }
      },

      formatTelefone(telefone){
        if (telefone) {
          if (/^0800\d{7}$/.test(telefone) || /^0800\d{8}$/.test(telefone)) {
            return telefone.replace(/^(\d{4})(\d{3})(\d{4})$/, "$1 $2-$3");
          } else if(/^\d{11}$/.test(telefone)) {
            return telefone.replace(/^(\d\d)(\d{5})(\d{4})$/, "($1) $2-$3");
          } else {
            return telefone.replace(/^(\d\d)(\d{4})(\d{4})$/, "($1) $2-$3");
          } 
        }
      },
    },


    computed: {
      resultadosPrestador() {
        return this.$store.state.resultPrestador;
      },

      planoSelecionado (){
        return this.$store.state.planoAtual;
      },
      

      ...mapState(['statusLoadingResultado', 'planoAtual'])
    },

    components: { MapsPrestador, PlanosAtendidos},
  }
</script>
